import './App.css';
import NavBar from "./components/NavBar";
import UserInputDataParent from './components/UserInputDataParent';



function App() {
  return (
    <div className="app">
      <NavBar />
      
      <UserInputDataParent />
    </div>
  );
}

export default App;